import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  FormFeedback,
} from "reactstrap";
import Select from "react-select";
import { resourcesZones, resourcesRoutes } from "../../../helpers/backend_helper";
import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from "../../../components/Fields/NibbleInput";

// Color con el que nace una zona nueva. Lo usa tambien el itemBase de Zonas.js:
// si solo viviera aqui como fallback del input, el selector mostraria este verde
// sin que Formik tuviera valor, y al guardar sin tocarlo la zona quedaria en NULL.
export const COLOR_ZONA_DEFAULT = "#3cd188";

const AddUpdModal = ({
  modal,
  setModal,
  items,
  setItems,
  setItem,
  item,
  authUser,
}) => {
  const [routes, setRoutes] = useState([]);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
    setItem({ ...item });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object({
      name: Yup.string().nullable(true).required("Requerido"),
      color: Yup.string().nullable(true),
      route_id: Yup.number().nullable(true).required("Requerido"),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  useEffect(() => {
    if (authUser.profile_id != 3) {
      resourcesRoutes("get", {}).then((response) => {
        setRoutes(response.data);
      });
    }
  }, []);

  const save = async (data) => {
    try {
      setLoading(true);
      const response = modal.update
        ? await resourcesZones("put", data, data.id)
        : await resourcesZones("post", data);
      responseAction(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.zona;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
      }
      setItems(array);
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
      setErrors(response.response?.data?.errors ?? []);
    }
  };

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar" : "Agregar"} Zona
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              {authUser.profile_id == 2 && (
                <div className="col-sm-12">
                  <label className="form-label">Ruta:</label>
                  <Select
                    className={classNames({
                      "is-invalid":
                        validation.touched.route_id &&
                        validation.errors.route_id,
                    })}
                    classNamePrefix="select"
                    isClearable={true}
                    value={
                      routes.filter(
                        (e) => e.id == validation.values.route_id
                      )[0] ?? null
                    }
                    isSearchable={true}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option.id}`}
                    name="route_id"
                    options={routes}
                    onChange={(option) => {
                      validation.setFieldValue("route_id", option?.id ?? null, true);
                    }}
                  />
                  <FormFeedback type="invalid">
                    {validation.errors.route_id}
                  </FormFeedback>
                </div>
              )}
              <NibbleInput
                md={12}
                label="Nombre:"
                fieldName="name"
                fieldType="text"
                maxLength="100"
                validation={validation}
              />
              {/* La boletera agrupa los destinos por zona y los pinta con este color */}
              <div className="col-md-12 mt-2">
                <label className="form-label">Color:</label>
                <input
                  type="color"
                  className="form-control form-control-color"
                  name="color"
                  value={validation.values.color || COLOR_ZONA_DEFAULT}
                  onChange={(e) => validation.setFieldValue("color", e.target.value, true)}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
